import script from "./software-usage.vue?vue&type=script&lang=ts&setup=true"
export * from "./software-usage.vue?vue&type=script&lang=ts&setup=true"

import "./software-usage.vue?vue&type=style&index=0&id=115cc21e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115cc21e"]])

export default __exports__